import { price as priceUtils } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { breakpoints, Stack, Text, textColors } from '@etg/wings';
import { ScreenReaderPrice } from '@eti/components';
import { dataCellStyles } from '../utils/summaryStyles';
import { screenReaderOnly } from '../../../../common/utils/styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const cellStyles = css`
  ${dataCellStyles};

  @media (max-width: 47.9375em) {
    display: block;
    margin-left: 36px;
    max-width: 35%;

    html[dir='rtl'] & {
      margin-left: 0;
      margin-right: 36px;
    }
  }
`;
const seatPriceTextStyles = css`
  font-size: 0.625rem;

  @media (min-width: ${breakpoints._768}) {
    font-size: 0.875rem;
  }
`;
const SummaryPriceCellWithPriceBreakdown = _ref => {
  var _carrier$name;
  let {
    carrier,
    markup,
    seatPrice
  } = _ref;
  const {
    t
  } = useTranslation();
  if (typeof seatPrice !== 'number') {
    return /*#__PURE__*/_jsx("td", {});
  }
  const normalizedMarkup = markup !== null && markup !== void 0 ? markup : 0;
  const formattedPrice = priceUtils.formatPrice(seatPrice);
  const markupPrice = priceUtils.formatPrice(normalizedMarkup);
  const providerPrice = priceUtils.formatPrice(seatPrice - normalizedMarkup);
  const carrierName = (_carrier$name = carrier.name) !== null && _carrier$name !== void 0 ? _carrier$name : '';
  const markupLabel = t('Product.Markup.Label');
  const pricebreakdownLabel = t('ScreenReader.Product.Pricebreakdown.Label');
  const seatLabel = t('Product.SeatMap.Seat.Price');
  const priceBreakdownHtml = t('Product.Carrier.PriceBreakdown.Text', `<bdi>${carrierName} ${providerPrice}</bdi>`, `<bdi>${markupLabel} ${markupPrice}</bdi>`);
  const screenReaderText = `${pricebreakdownLabel}: ${priceBreakdownHtml}`;
  return /*#__PURE__*/_jsx("td", {
    className: cellStyles,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: 4,
      children: [/*#__PURE__*/_jsxs(Text, {
        "aria-hidden": "true",
        className: seatPriceTextStyles,
        "data-testid": "summary-price-cell-price",
        children: [seatLabel, " ", formattedPrice]
      }), /*#__PURE__*/_jsx("span", {
        className: screenReaderOnly,
        children: seatLabel
      }), /*#__PURE__*/_jsx(ScreenReaderPrice, {
        price: formattedPrice
      }), carrierName && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          "aria-hidden": "true",
          asHtml: true,
          className: seatPriceTextStyles,
          color: textColors.SECONDARY,
          "data-testid": "summary-price-cell-price-breakdown-html",
          children: priceBreakdownHtml
        }), /*#__PURE__*/_jsx(Text, {
          asHtml: true,
          className: screenReaderOnly,
          "data-testid": "summary-price-cell-price-breakdown-text",
          children: screenReaderText
        })]
      })]
    })
  });
};
export default SummaryPriceCellWithPriceBreakdown;
//# sourceMappingURL=SummaryPriceCellWithPriceBreakdown.js.map